import { createSlice } from '@reduxjs/toolkit'
import { RUB } from '../../utils/constants/currency'

const defaultCurrency = RUB

const initialState = defaultCurrency

export const currencySlice = createSlice({
    name: 'currency',
    initialState,
    reducers: {
        setCurrency: (state, action) => action.payload
    }
})

export const { setCurrency } = currencySlice.actions

export const selectCurrency = (state) => state.currency

export default currencySlice.reducer
